module.exports = __webpack_public_path__ + "static/hero_image-18cd088de442679048a0255ec9aa1696.jpg";